import { EmailTemplate } from '../models';
import type { EmailTemplateVariable } from '../models';
import { ResourceWithAttachments } from './attachments';

export class EmailTemplates extends ResourceWithAttachments<EmailTemplate> {
  model = EmailTemplate;

  resourcePath = 'v1/email-templates';

  async getVariables(): Promise<EmailTemplateVariable[]> {
    return this.api.get(this.path('variables')).then((res) => {
      return res.data.data as EmailTemplateVariable[];
    });
  }
}
